export function toDateTime(timestamp) {
    let dateTime = new Date(timestamp * 1000);
    // return dateTime.toDateString() + " " + dateTime.getUTCHours() + ":" + dateTime.getUTCMinutes() + "UTC" + dateTime.getTimezoneOffset();
    return dateTime.toUTCString()
}